const SECTIONS = {
    CONTENT: 'content',
    OPTIONS: 'options',
    ANSWER: 'answer',
    SYLLABUS: 'syllabus',
    HINTS: 'hints',
    SOLUTION: 'solution',
    DIFFICULTY: 'difficulty',
    RELEVANT_EXAMS: 'relevantExams',
    BENCHMARKING: 'benchmarking',
    TAGS: 'tags',
    IDEAL_TIME: 'idealTime'
};

const FEEDBACK_AUTHOR_ACTIONS = {
    RESOLVED: 'resolved',
    CHALLENGED: 'challenged',
    EDITED: 'edited',
    CREATED: 'created',
    MODIFIED: 'modified',
};

const FEEDBACK_VALIDATOR_ACTIONS = {
    APPROVED: 'approved',
    REJECTED: 'rejected',
    NO_ACTION: 'noAction',
    IN_REVIEW: 'inReview',
    RE_SUBMITTED: 'resubmitted',
    ACCEPTED: 'accepted',
    OPEN: 'open',
    REVIEW_POOL: 'reviewPool',
    PUBLISHED: 'published',
    QUEUED: 'queued',
};

const NEW_FEEDBACK_TIME_TO_SHOW = 'Just Now';

const SUBMIT_MODAL_BODY_TEXT = {
    REJECTED: 'You have rejected this question. Your feedback has been sent to the author for resolution',
    FIRST_APPROVAL: 'You have approved this question and this will now be submitted for 2nd Validation.',
    SECOND_APPROVAL: 'You have approved this question which has now been published and is now available under "All Content" section of My Library.',
    FIRST_APPROVAL_WITH_CONFLICT: 'You have approved this question and this will now be submitted for 3rd Validation.',
};

const FOOTER_TEXT = {
    VALIDATOR: 'Please review all parts of this question thoroughly for correctness and completeness. You can approve this question or reject it by giving appropriate feedback.',
    VALIDATING: 'You can click on relevant question component(s) to submit feedback points for those component(s) (Concept, Question, Options, Correct Answer, Solution, Hints, Relevant Exams, Benchmarking, etc.)',
    AUTHOR: 'Click on individual feedback and resolve/challenge all the feedback before proceeding further.'
};

const CONTENT_SUBMIT_MODAL_BODY = {
    SUBMIT: {
        heading: 'Request for Validation Initiated',
        body: 'Question has been created and sent for validation/approval.',
    },
    SUBMIT_TO_ANOTHER_VALIDATOR: {
        heading: 'Validation Request Sent',
        body: 'Question has been sent for approval to a new validator.',
    },
    RE_SUBMIT: {
        heading: 'Request for Approval Sent',
        body: 'Question has been updated and sent for validation/approval to the same validator.',
    },
    DIRECT_PUBLISH: {
        heading: 'Request for Validation Initiated',
        body: 'The question was published successfully, and a duplicate of this question has been sent for Validation',
    },
};

const VALIDATION_ROLES = {
    AUTHOR: 'author',
    VALIDATOR: 'validator',
};

const CONTENT_SUB_TYPE = {
    OPTIONS: 'options',
    ANSWER: 'answer',
    SOLUTION: 'solution',
    HINTS: 'hints',
    DIFFICULTY: 'difficulty',
    IDEAL_TIME: 'idealTime',
    RELEVANT_EXAM: 'relevantExams',
    BENCHMARKING: 'benchmarking',
    CORRECT_ANSWER: 'correctAnswer',
    EXTRA_TAGS: 'tags'
}

const VALIDATION_ACTION_DAYS = {
    RESUBMITTED: 7
};

const VALIDATION_PLACEHOLDER: any = {
    AUTHOR: ' Add your remark',
    VALIDATOR: 'Write your remarks here',
    CHALLENGE: 'Please Add your Remark to Challenge',
    RESOLVE: 'Please Add your Remark to Resolve',
    resubmittedToSameValidator: 'resubmitted the question to same validator',
    resubmittedToAnotherValidator: 'resubmitted the question to another validator',
};

const EDIT_BUTTON_STYLE = {
    MAX_HEIGHT: '150px',
    VIEW_MORE_PADDING: '10px',
    VIEW_LESS_PADDING: '45px',
    FIT_CONTENT: 'fit-content',
    VIEW_MORE: 'View More',
    VIEW_LESS: 'View Less',
    DISPLAY_BLOCK: 'block',
    CONTAINER_HEIGHT: 100
};

const SIDEBAR_TAB = {
    FEEDBACK: 'feedbackSec',
    EDIT_HISTORY: 'historySec'
}

const FEEDBACK_INPUT_ACTIONS = {
    CHALLENGE: 'challenge',
    RESOLVE: 'resolve'
}

const QUESTION_SUBMIT = {
    SUBMIT_FOR_VALIDATION: 'Submit for Validation',
    SUBMIT_REQUEST: 'Submit Request',
}
const FEEDBACK_STATUS = {
    OPEN: 'open',
    RESOLVED:'resolved',
    CHALLENGED: 'challenged',
}

const FEEDBACK_STATUS_TEXTS =  {
    collapseAll: 'Collapse All',
    expandAll: 'Expand All',
    authorReplied: 'Author Replied',
    userReplied: 'You Replied',
    authorInitial: 'A',
    validatorInitial: 'V'
}

export {
    SECTIONS,
    FEEDBACK_AUTHOR_ACTIONS,
    FEEDBACK_VALIDATOR_ACTIONS,
    NEW_FEEDBACK_TIME_TO_SHOW,
    SUBMIT_MODAL_BODY_TEXT,
    VALIDATION_ROLES,
    CONTENT_SUBMIT_MODAL_BODY,
    CONTENT_SUB_TYPE,
    VALIDATION_ACTION_DAYS,
    VALIDATION_PLACEHOLDER,
    EDIT_BUTTON_STYLE,
    FOOTER_TEXT,
    SIDEBAR_TAB,
    FEEDBACK_INPUT_ACTIONS,
    QUESTION_SUBMIT,
    FEEDBACK_STATUS,
    FEEDBACK_STATUS_TEXTS
};